import React from 'react';
import PropTypes from 'prop-types';
import InputWithLabel from '../InputWithLabel/InputWithLabel';
import Button from '../Button/GlyphedButton';
import {PencilGlyph} from '../../glyphicons/Glyphicons';
import './Picker.scss';

const Picker = ({buttonId, buttonText, inputId, inputLabel, inputPlaceholder, inputValue, onPickerButtonClick}) => {
    return(
        <div className="col-xs-12">
            <InputWithLabel
                className="col-xs-12 col-sm-6 col-md-6"
                disabled
                id={inputId}
                label={inputLabel}
                placeholder={inputPlaceholder}
                type="text"
                value={inputValue}/>
            <div className="col-xs-12 col-sm-6 col-md-4 form-group">
                <Button
                    className="picker-button"
                    id={buttonId}
                    glyphComponent={<PencilGlyph className="btn-glyphicon"/>}
                    label={buttonText}
                    onClick={onPickerButtonClick}/>
            </div>
        </div>
    );
};

Picker.propTypes = {
    //Html id attribute for button.
    buttonId: PropTypes.string,
    //Text to display on button.
    buttonText: PropTypes.string,
    //Html id attribute for input.
    inputId: PropTypes.string,
    //Input label.
    inputLabel: PropTypes.string,
    //Input placeholder
    inputPlaceholder: PropTypes.string,
    //Input value
    inputValue: PropTypes.string,
    //Function triggered when button is clicked
    onPickerButtonClick: PropTypes.func
};

export default Picker;


// WEBPACK FOOTER //
// ./src/components/base/Picker/Picker.js